import { useTranslation } from 'next-i18next';
import styles from '@components/MenuLabels/MenuLabels.styles';
import theme from '@styles/theme';
type PropsType = {
  isNew?: boolean;
  isPersonalization?: boolean;
  isPromo?: boolean;
};
const MenuLabels = ({
  isNew = false,
  isPersonalization = false,
  isPromo = false
}: PropsType) => {
  const {
    t
  } = useTranslation('common');
  const renderLabel = () => {
    if (isPromo) return <sup sx={styles.styledLabel(theme.rawColors.accent700)}> {t('specialOffer')}</sup>;
    if (isNew) return <sup sx={styles.styledLabel(theme.rawColors.neutralBlack)}> {t('new')}</sup>;
    if (isPersonalization) return <sup sx={styles.styledLabel(theme.rawColors.webGreen500)}> {t('customize')}</sup>;
    return null;
  };
  return renderLabel();
};
export default MenuLabels;